module.exports = __webpack_public_path__ + "static/media/aliseo.98ebbaae.png";